<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-13 09:57:02
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 17:25:07
-->
<template>
    <div id="box" class="box">
        <div id="left" class="left">
            <div style="font-weight: 600;" class="title">组织架构</div>
            <div class="search">
                <a-input-search
                    v-model="organizationName"
                    placeholder="搜索组织架构名称"
                    size="large"
                    @search="search"
                >
                    <template #enterButton @click="search">
                        <img class="img" src="@/assets/images/search.jpg" />
                    </template>
                </a-input-search>
            </div>
            <div @click="closeAll">
                <img class="close-img" src="@/assets/images/close.jpg" /><span
                    class="close-name"
                    >全部收缩</span
                >
            </div>
            <a-spin :spinning="leftLoading">
                <div class="ant-tree">
                <a-tree
                    show-line
                     :style="{height:heightLeft,overflowY:'auto',overflowX:'hidden'}"
                    :tree-data="treeData"
                    @select="onSelect"
                    v-if="treeData.length > 0"
                    :autoExpandParent="isCloseAll"
                    :defaultExpandedKeys="defaultExpandedKeys"
                    :selectedKeys="checkedKeys"
                >
                </a-tree>
            </div>
            </a-spin>
            
        </div>
         <div id="resize"></div>
        <div id="right" class="right">
            <div class="right-name">微信公众号-{{organizationNameTwo}}</div>
            <div class="log-box">
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                    <el-tab-pane label="我授权的公众号" name="first"></el-tab-pane>
                    <el-tab-pane label="其他人授权的公众号" name="second"></el-tab-pane>
                </el-tabs>
            </div>
           
            <div class="top">
                <el-button  v-if="codeData.indexOf('107') != -1" type="primary" @click="addAdminFn">授权公众号</el-button
                >
                <div class="search">
                    <a-input
                        style="width: 170px; margin-right: 20px"
                        v-model="name"
                        placeholder="微信公众号"
                    />
                    <el-button type="primary" @click="searchTwo">查询</el-button>
                </div>
            </div>
            <coententTable
                :y="height"
                @handleTableChange="handleTableChange"
                @onShowSizeChange="onShowSizeChange"
                :columns="type == 1 ? columns : columnsTwo"
                :dataSource="dataSource"
                :customSlot="customSlot"
                :loading="loading"
            >
                <template v-slot:name="scopeVal">
                    <div class="tr-one">
                        <div class="quan"></div>
                        <div class="overflow">
                              <span :title="scopeVal.scope.nickName"  style="margin-left: 10px">{{
                            scopeVal.scope.nickName
                        }}</span>
                        </div>
                    </div>
                </template>
                <template v-slot:state="scopeVal">
                    <span :class="[scopeVal.scope.state == 1?'Status1':scopeVal.scope.state == 2?'Status2':'']"
                        
                        >{{
                            scopeVal.scope.state == 0
                            ? "未授权"
                            : scopeVal.scope.state == 1
                            ? "有效授权"
                            : "已取消授权"
                        }}</span
                    >
                </template>
                <template v-slot:operation="scopeVal">
                    <div style="display: flex;">
                         <div
                                v-if="scopeVal.scope.state == 1 && codeData.indexOf('108') != -1"
                                @click="cancelPreAuth=true"
                                class="btnTwo"
                                style="margin-right: 14px;width:66px"
                                >取消授权</div
                            >
                            <div class="btnFour" style="margin-right: 14px;width:66px" v-if="scopeVal.scope.state == 2 && codeData.indexOf('108') != -1"
                                >取消授权</div
                            >
                            <div
                                v-if="scopeVal.scope.state == 2 && codeData.indexOf('109') != -1"
                                @click="deletePreAuth(scopeVal.scope.id)"
                                class="btnThree"
                                >删除</div
                            >
                            <div
                            class="btnFour"
                                v-if="scopeVal.scope.state == 1 && codeData.indexOf('109') != -1"
                                >删除</div
                            >
                    </div>
                </template>
            </coententTable>
            <div id="pagination" class="pagination">
                <a-pagination
                    :current="pagination.current"
                    :pageSize="pagination.pageSize"
                    show-size-changer
                    show-quick-jumper
                    :total="pagination.total"
                    @change="onShowSizeChange"
                    @showSizeChange="handleTableChange"
                    :page-size-options="pagination.pageSizeOptions"
                    :show-total="(total) => `共 ${pagination.total} 条`"
                />
            </div>
        </div>
        <el-dialog
            title="温馨提示"
            :visible.sync="cancelPreAuth"
            width="500px"
            top="17%"
            :before-close="close"
            >
            <div>
                <div>请访问微信公众平台（地址：<a target="_blank" href="https://mp.weixin.qq.com">https://mp.weixin.qq.com</a>），在公众号设置-授权管理中进行取消授权操作</div>
                <div class="btn">
                    <a-button @click="close">知道了</a-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import { selectListPage,organTree,getPreAuthCodet,deleteById} from "./weChat_official_account.js";
import { message } from 'ant-design-vue';
export default {
    data() {
        return {
            type: 1,
            height: 0,
            isCloseAll: false,
            expandedKeys: [],
            selectedKeys: [],
            heightLeft:0,
            checkedKeys:[],
            treeData: [],
            organization: "",
            organizationName: "",
            organizationNameTwo:'',
            name: "",
            activeName:'first',
            loading:false,
            role: undefined,
            columns: [
                {
                    title: "微信公众号",
                    dataIndex: "name",
                    ellipsis: true,
                    scopedSlots: { customRender: "name" },
                    customCell: column => {
                            return {
                            style: {
                                'min-width': "320px",
                                'max-width': "500px",
                            }
                        };
                        },
                        customHeaderCell: column => {
                        return {
                            style: {
                                'min-width': "320px",
                                'max-width': "500px",
                            }
                        };
                        }
                },
                {
                    title: "状态",
                    dataIndex: "state",
                     width: 120,
                    ellipsis: true,
                    scopedSlots: { customRender: "state" },
                },
                {
                    title: "授权人",
                    dataIndex: "grantName",
                     width: 120,
                    ellipsis: true,
                },
                {
                    title: "授权时间",
                    dataIndex: "grantTime",
                     width: 200,
                    ellipsis: true,
                },
                {
                    title: "权限刷新时间",
                    dataIndex: "refreshTime",
                     width: 200,
                    ellipsis: true,
                },
                {
                    title: "操作",
                    dataIndex: "operate",
                    scopedSlots: { customRender: "action" },
                    width: 200,
                    fixed: "right",
                },
            ],
            customSlot: [
                {
                    name: "name",
                    customRender: "name",
                },
                {
                    name: "state",
                    customRender: "state",
                },
            ],
            columnsTwo: [
                {
                    title: "微信公众号",
                    dataIndex: "name",
                    ellipsis: true,
                    scopedSlots: { customRender: "name" },
                      customCell: column => {
                            return {
                            style: {
                                'min-width': "320px",
                                'max-width': "500px",
                            }
                        };
                        },
                        customHeaderCell: column => {
                        return {
                            style: {
                                'min-width': "320px",
                                'max-width': "500px",
                            }
                        };
                        }
                },
                {
                    title: "状态",
                    dataIndex: "state",
                    width: 120,
                    ellipsis: true,
                    scopedSlots: { customRender: "state" },
                },
                {
                    title: "授权人",
                    dataIndex: "grantName",
                     width: 120,
                    ellipsis: true,
                },
                {
                    title: "授权时间",
                    dataIndex: "grantTime",
                     width: 200,
                    ellipsis: true,
                },
                {
                    title: "权限刷新时间",
                    dataIndex: "refreshTime",
                     width: 200,
                    ellipsis: true,
                },
            ],
            pagination: {
                current: 1,
                pageSize: 15,
                total: 0,
                pageSizeOptions: ["15", "25", "35"],
            },
            dataSource: [],
            cancelPreAuth:false,
            codeData:[],
            leftLoading:false,
            defaultExpandedKeys:[],
        };
    },
    components: {
        coententTable,
    },
    mounted() {
        this.getOrganTree();
        this.heightLeft = `${document.documentElement.clientHeight - 290}px`;
        this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
        this.$nextTick(()=>{
              var left = document.getElementById("left");
            var box = document.getElementById("box");
            var right = document.getElementById("right");
            var pagination = document.getElementById("pagination");
            left.style.width = 250 + "px";
            right.style.width = (box.clientWidth - 250 - 5) + "px";
            pagination.style.width = (box.clientWidth - 250 + 5) + "px";
        })
        this.getLeftMove();
    },
    methods: {
        searchTwo(){
            this.pagination.current = 1;
            this.getListPage()
        },
         getLeftMove(){
            var resize = document.getElementById("resize");
            var left = document.getElementById("left");
            var right = document.getElementById("right");
            var box = document.getElementById("box");
            var pagination = document.getElementById("pagination");
            resize.onmousedown = function(e){
                var startX = e.clientX;
                resize.left = resize.offsetLeft;
                document.onmousemove = function(e){
                var endX = e.clientX;

                var moveLen = resize.left + (endX - startX);
                var maxT = box.clientWidth - resize.offsetWidth;
                if(moveLen<250) moveLen = 250;
                if(moveLen>600) moveLen = 600;  
                if(moveLen>maxT-150) moveLen = maxT-150;

                resize.style.left = moveLen;
                left.style.width = moveLen + "px";
                right.style.width = (box.clientWidth - moveLen - 5) + "px";
                pagination.style.width = (box.clientWidth - moveLen + 5) + "px";

                }
                document.onmouseup = function(evt){
                document.onmousemove = null;
                document.onmouseup = null; 
                resize.releaseCapture && resize.releaseCapture();
                }
                resize.setCapture && resize.setCapture();
                return false;
            }
        },
        addAdminFn() {
            getPreAuthCodet({id:sessionStorage.getItem("siteId")}).then(res=>{
                if(res.code == 0){
                     window.open(`${res.data.oauthUrl}`);
                }
            })
        },
         handleClick(){
                if(this.activeName == 'first'){
                    this.type = 1;
                    this.changeType(1)
                }
                if(this.activeName == 'second'){
                    this.type = 2;
                    this.changeType(2)
                }
            },
        closeAll() {
            this.isCloseAll = false;
            this.$nextTick(() => {
                this.isCloseAll = true;
            });
        },
        changeType(type) {
            this.type = type;
            this.getListPage()
        },
        onSelect(key, event) {
            this.organization = key[0];
            if(key.length == 0){
                return;
            }
            this.organizationNameTwo = event.node._props.title;
            this.pagination.current = 1;
            this.getListPage();
            this.checkedKeys = [this.organization]
        },
        search() {
            this.getOrganTree();
        },
        // 切换 搜索
        selectFn(value) {
            this.selectValue = value;
        },
        onShowSizeChange(current) {
            this.pagination.current = current;
            this.getListPage();
        },
        handleTableChange(page,pageSize) {
            this.pagination.current = 1;
            this.pagination.pageSize = pageSize;
            this.getList();
        },
        //授权列表数据
        getListPage() {
            const _this = this;
            this.loading = true;
            this.dataSource = [];
            let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            let userId = _this.type == 1 ? userInfo.id : "";
            let reqData = {
                current: _this.pagination.current,
                siteId: sessionStorage.getItem("siteId"),
                size: _this.pagination.pageSize,
                orgId: _this.organization,
                name: _this.name,
                userId: userId,
            };
            selectListPage(reqData).then((res) => {
                if (res.code == 0) {
                    _this.dataSource = JSON.parse(JSON.stringify(res.data.records));
                    _this.pagination.current = res.data.current;
                    _this.pagination.pageSize = res.data.size;
                    _this.pagination.total = res.data.total;
                    if(_this.pagination.total > 0){
                        this.height = document.documentElement.clientHeight - 500;
                         this.heightLeft = `${document.documentElement.clientHeight - 290}px`;
                        window.onresize = () => {
                            return (() => {
                                this.height = document.documentElement.clientHeight - 500;
                                this.heightLeft = `${document.documentElement.clientHeight - 290}px`;
                                
                                var left = document.getElementById("left");
                                var box = document.getElementById("box");
                                var right = document.getElementById("right");
                                var pagination = document.getElementById("pagination");
                                left.style.width = 250 + "px";
                                right.style.width = (box.clientWidth - 250 - 5) + "px";
                                pagination.style.width = (box.clientWidth - 250 + 5) + "px";
                            })();
                        };
                    }
                    if (_this.pagination.current != 1 && _this.dataSource.length == 0) {
                    _this.pagination.current--;
                    _this.getListPage();
                    }
                    _this.loading = false;
                }
            });
        },
        getOrganTree(){
            const _this = this
            this.leftLoading = true;
            organTree({name:_this.organizationName}).then(res=>{
                if(res.code == 0){
                    if(res.data.length > 0){
                        this.organization = res.data[0].id;
                        this.checkedKeys = [this.organization]
                        this.organizationNameTwo = res.data[0].organizationName;
                    }
                    this.leftLoading = false;
                    this.getListPage();
                    let options = JSON.stringify(res.data)
                        .replace(/organizationName/g, "title")
                        .replace(/id/g, "key");
                    _this.treeData = JSON.parse(options);
                    this.defaultExpandedKeys = [_this.treeData[0].key];
                }
            })
        },
        close(){
            this.cancelPreAuth = false
        },
        deletePreAuth(id){
            deleteById({id:id}).then(res=>{
                if(res.code==0){
                    message.success(res.msg)
                    this.getListPage();
                }
            })
        }
        
    },
};
</script>

<style lang="less" scoped>
.box {
    display: flex;
    width: 100%;
    height:100%;
    max-height: calc(94% - 11px);
    //position: relative;
    .left {
        width: 250px;
        font-size: 14px;
        color: #000;
        padding: 24px;
        height: calc(107.5% - 3px);
        border-right: solid 1px #E4E7ED;
        .title {
            margin-bottom: 24px;
        }
        .search {
            margin-bottom: 12px;
        }
        /deep/ .ant-btn-primary {
            background: #1890ff;
            padding: 0 5px;
        }
        /deep/ input::-webkit-input-placeholder {
            color: #415058;
        }
        /deep/ .ant-input {
            background: #f7f7f7;
        }
    }
    .right {
        flex: 1;
        height: 100%;
        width: 100%;
        font-size: 14px;
        padding-top: 24px;
        //border-left: solid 2px #f2f3f5;
        padding-bottom: 33px;
        width: 500px;
        .right-name {
            padding-left: 24px;
            color: #000;
            font-weight: 600;
        }
        .log-box {
            //border-bottom: solid 1px #dcdfe6;
           // display: flex;
            margin-left: 24px;
            margin-right: 24px;
            margin-top: 24px;
            // .log {
            //     padding: 10px 20px;
            //     border-top: solid 1px #dcdfe6;
            //     border-left: solid 1px #dcdfe6;
            //     cursor: pointer;
            //     border-bottom: solid 1px #dcdfe6;
            // }
            // .log:last-child {
            //     border-right: solid 1px #dcdfe6;
            //     border-top-right-radius: 10px;
            // }
            // .log:first-child {
            //     border-top-left-radius: 10px;
            // }
        }
        .search {
            display: flex;
            /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-select .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
        }

        /deep/ .ant-table-wrapper {
           // width: 100%;
        }
    }
}
.top {
    padding: 24px;
    padding-bottom: 0px;
    display: flex;
    justify-content: space-between;
    .search {
        display: flex;
    }

    .add-img {
        margin-top: -2px;
        margin-right: 3px;
    }
}
 .ant-tree {
    overflow: hidden;
    overflow-y: auto;
    min-height: 300px;
}
.dir {
    height: 1px;
    background: #dcdfe6;
    margin-left: 330px;
    margin-right: 24px;
    margin-top: -1px;
}
.middle {
    height: calc(113% - 4px);
    width: 1px;
    background: #f4f4f6;
}
.tr-one {
    display: flex;
}
.quan {
    width: 24px;
    height: 24px;
    background: #fff;
    border: solid 1px #ccc;
    border-radius: 50%;
}
.close-name {
    color: #303133;
    font-weight: 400;
    margin-top: 4px;
}
.close-img {
    margin-top: -1px;
    margin-right: 4px;
    cursor: pointer;
}
.Status1{
    color:#67c23a;
}
.Status2{
    color:#f56c6c
}
.btn{
  margin-top: 24px;
  text-align: right;
}
/deep/ .ant-pagination-options {
  float: left;
  margin-right: 58px;
}
/deep/ .ant-pagination-total-text {
  float: left;
}
/deep/ .ant-pagination-options-quick-jumper {
  position: absolute;
  right: 20px;
}
/deep/ .ant-pagination {
  margin-right: 124px;
}
.pagination {
  display: flex;
  padding: 12px;
  padding-right: 0px;
  justify-content: right;
  border-top: solid #E4E7ED 1px;
  position:absolute;
  bottom: 0;
  width: calc(100% - 530px);
  padding-right: 24px;
  margin-left: -5px;
}
/deep/ .ant-pagination-item-active {
  background: #1890ff;
}
/deep/ .ant-pagination-item-active a {
  color: #fff;
}
.overflow{
  overflow:hidden; 
  white-space: nowrap;
  text-overflow: ellipsis; 
  -o-text-overflow:ellipsis;
  width: 150px;
}
/deep/ .ant-spin-nested-loading{
    width: 100%;
}
.el-button--primary {
  background: #176de6;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-tabs__header{
    margin: 0px;
}
#resize{
  width:5px;
  height:100%;
  cursor: w-resize;
  float:left;
}
</style>